<div class="main-panel">
  <!-- BEGIN : Main Content-->
  <div class="main-content">
    <div class="content-wrapper">
      <div>
        <section id="scroll-dynamic">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="form-section"><i class="ft-user"></i> Device Info</h4>
                  <hr>
                  <br>
                  <form class="form form-horizontal">
                    <div class="form-body">

                      <div class="row">
                        <div class="col-md-12">
                          <div *ngIf="!IsLoadAllUsers" class="form-group row">
                            <label class="col-md-2 label-control" for="userinput5">Select Device </label>
                            <div class="col-sm-3 col-6">
                              <select (change)="selectChangeHandler($event)"  class="browser-default custom-select">
                                <option value="0" selected>Select Device</option>
                                <option *ngFor="let item of Device" value="{{item.device_id}}">{{item.deviceName}}
                                </option>
                              </select>


                            </div>
                            <div class="col-sm-6 col-6 ">
                              <div class="float-right">
                                <button *ngIf="!AddUserMode" (click)="AddUserToggle()" class="btn btn-success">Add new
                                  User </button>
                              </div>
                            </div>


                          </div>
                          <div  class="form-group row">
                            <label class="col-md-2 label-control" for="customSwitch10"></label>
                            <div class="col-sm-3 col-6">
                              <div *ngIf="toggleLoadAllUserSwitch" class="custom-control-inline custom-switch">

                                <input (change)="LoadAllUsersFromAllDevice()"  type="checkbox" class="custom-control-input" id="customSwitch10" [checked]="IsLoadAllUsers" >
                                <label class="custom-control-label" for="customSwitch10">Load All Users</label>
                              </div>
                            </div>

                            <div *ngIf="IsLoadAllUsers" class="col-sm-6 col-6 ">
                              <div class="float-right">
                                <button (click)="DeleteSelectedUser()" class="btn btn-danger">Delete
                                  User </button>
                              </div>
                            </div>
                          </div>
                        </div>



                      </div>

                    </div>
                  </form>

                </div>
                <div class="card-content">

                  <div *ngIf="!Mode && IsLoadAllUsers==false" class="card-body card-dashboard table-responsive">
                    <div *ngIf="dataTable">
                      <table datatable class="table table-striped table-bordered dynamic-height">
                        <thead>
                          <tr>
                            <th>User ID</th>
                            <th>User Name</th>
                            <th>Privilige</th>
                            <th>Device Name</th>
                            <th>Mode</th>

                          </tr>
                        </thead>
                        <tbody>


                          <tr *ngFor="let item of Users">

                            <td>{{item.userID}}</td>
                            <td>{{item.username}}</td>
                            <td>{{item.user_Privilege}}</td>
                            <td>{{item.deviceName}}</td>
                            <td>
                              <button title="Delete From Database" class="btn btn-danger btn-primary-spacing col-xs-2"
                                (click)="DeleteUserFromDB(item.userID)"><i class="fa fa-database"
                                  aria-hidden="true"></i></button>
                                  &nbsp;
                                  &nbsp;

                              <button title="Delete From Device" class="btn btn-info btn-primary-spacing col-xs-2"
                                (click)="DeleteUser(item.userID)"><i class="fa fa-cog" aria-hidden="true"></i></button>
                                &nbsp;
                                &nbsp;
                                <button title="Edit User" (click)="EditUserToggle(item)" class="btn btn-warning btn-primary-spacing col-xs-2"
                               ><i class="fa fa-pencil"  aria-hidden="true"></i></button>
                            </td>
                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>



                  <div *ngIf="IsLoadAllUsers" class="card-body card-dashboard table-responsive">
                    <div *ngIf="UserdataTable">
                      <table datatable class="table table-striped table-bordered dynamic-height">
                        <thead>
                          <tr>
                            <th>
                              <input type="checkbox" [checked]="isChecked" (click)="checkuncheckall()">
                            </th>
                            <th>User ID</th>
                            <th>User Name</th>
                            <th>Privilige</th>


                          </tr>
                        </thead>
                        <tbody>


                          <tr *ngFor="let item of Users">
                            <td><input type="checkbox" [checked]="isChecked" (click)="CheckUser($event,item.userID)"></td>
                            <td>{{item.userID}}</td>
                            <td>{{item.username}}</td>
                            <td>{{item.user_Privilege}}

                          </tr>
                        </tbody>

                      </table>
                    </div>
                  </div>

                  <div *ngIf="AddUserMode" class="card-body card-dashboard table-responsive">
                    <app-AddUser [DeviceIDFromHome]="selectedDevice" (cancelAddUser)="CancelAddUserMode($event)">
                    </app-AddUser>
                  </div>

                  <div *ngIf="EditUserMode" class="card-body card-dashboard table-responsive">
                    <app-EditUser [DeviceIDFromHome]="selectedDevice" [User]="User" (cancelEditUser)="CancelEditUserMode($event)">
                    </app-EditUser>
                  </div>



                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <h3 style="color: white">Please Wait ... </h3>
  </ngx-spinner>
